import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getArticleById } from '../../services/knowledgeBaseService';
import '../Tickets/tickets.css';

export default function KnowledgeBaseArticle() {
  const { id } = useParams();
  // CHANGED: no longer reads useAuth()/loading here — this page is public
  // now, so there's nothing to gate on. api.js still attaches a token if
  // the visitor happens to be logged in, but it's optional.

  const [article, setArticle] = useState(null);
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const run = async () => {
      if (!id) return;
      setBusy(true);
      setError('');
      try {
        const data = await getArticleById(id);
        setArticle(data);
      } catch (e) {
        setError(e?.response?.data?.message || 'Failed to load article');
        setArticle(null);
      } finally {
        setBusy(false);
      }
    };
    run();
  }, [id]);

  // CHANGED: removed `if (loading) return null;` and
  // `if (!user) return <Navigate to="/login" replace />;` — the backend
  // route is public now (optionalAuth), so this component no longer
  // needs to gate on auth state at all.

  return (
    <div className="t-page">
      <div className="t-container" style={{ maxWidth: 900 }}>
        <div className="t-top">
          <h2 className="t-title">Knowledge Base</h2>
          <Link to="/knowledge-base" className="chat-link">
            Back
          </Link>
        </div>

        {error ? <div className="t-alert t-alert--error">{error}</div> : null}
        {busy ? <div className="t-alert">Loading...</div> : null}

        {!busy && article ? (
          <section className="t-card">
            <div className="t-headline">
              <h3 className="t-subject" style={{ marginBottom: 6 }}>
                {article.title}
              </h3>
              <div className="t-meta">
                {article.category?.name ? `Category: ${article.category.name}` : null}
              </div>
            </div>

            {/* If your backend content is plain text, this is safe.
                If it contains HTML, DON'T use dangerouslySetInnerHTML unless you sanitize. */}
            <div className="t-meta" style={{ marginTop: 12, whiteSpace: 'pre-wrap' }}>
              {article.content}
            </div>
          </section>
        ) : null}
      </div>
    </div>
  );
}